document.addEventListener('DOMContentLoaded', () => {
    'use strict';

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const TRANSITION_MS = 400; // matches .video-search-pill's duration-[400ms] in components.css

        document.querySelectorAll('.video-search-pills').forEach((container) => {
            const pills = container.querySelectorAll('.video-search-pill');

            if (pills.length < 2) {
                return;
            }

            let index = 0;

            setInterval(() => {
                const leaving = pills[index];

                // .is-leaving overrides the resting (below, not-yet-shown) position
                // with "above, just exited" for one transition, so the outgoing pill
                // continues upward through the top instead of dropping back down to
                // where it entered from.
                leaving.classList.remove('is-active');
                leaving.classList.add('is-leaving');

                index = (index + 1) % pills.length;
                pills[index].classList.add('is-active');

                setTimeout(() => {
                    leaving.classList.remove('is-leaving');
                }, TRANSITION_MS);
            }, 2400);
        });
    }

    // The arrow badge becomes a square flush against the search box on
    // hover (see .video-search-arrow in components.css). Its target size
    // is the box's own rendered height, which is fluid (clamp-based) —
    // not something CSS alone can match on a sibling — so read it here
    // and set it as an explicit pixel size, which still transitions
    // smoothly against the CSS rule's clamp() default.
    document.querySelectorAll('.video-search-cta').forEach((cta) => {
        const box = cta.querySelector('.video-search-box');
        const arrow = cta.querySelector('.video-search-arrow');

        if (!box || !arrow) {
            return;
        }

        cta.addEventListener('pointerenter', () => {
            const size = box.getBoundingClientRect().height + 'px';
            arrow.style.height = size;
            arrow.style.width = size;
        });

        cta.addEventListener('pointerleave', () => {
            arrow.style.height = '';
            arrow.style.width = '';
        });
    });
});
